import { createRoute } from '@tanstack/react-router';
import { Route as parentRoute } from '../index';
import KioskDevicesListPage from '@/features/kiosk/pages/KioskDevicesListPage';

export const Route = createRoute({
  getParentRoute: () => parentRoute,
  path: '/devices',
  component: KioskDevicesListPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      settingsId: search.settingsId as string | undefined,
    };
  },
});
